module.exports = __webpack_public_path__ + "static/media/treasure_golem.9005a191.png";